require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./trilegar-webinar.json") })
        }
      }, "path---trilegar-webinar");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---trilegar-webinar!./.cache/json/trilegar-webinar.json
// module id = 1223
// module chunks = 231608221292675